module.exports = __webpack_public_path__ + "account/img/195.bf4fd761.png";